var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "attribute-container mb-3" }, [
    _c(
      "div",
      [
        _c("label", { attrs: { for: _vm.componentId + "_new-name-text" } }, [
          _vm._v(_vm._s(_vm.resource("IOFormat_Attribute_Name_DisplayName")))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newName,
              expression: "newName"
            }
          ],
          staticClass: "form-control",
          attrs: { id: _vm.componentId + "_new-name-text", type: "text" },
          domProps: { value: _vm.newName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.newName = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _vm.showError
          ? _c("required", { attrs: { fieldName: "Name" } })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("label", [
          _vm._v(
            _vm._s(_vm.resource("IOFormat_Attribute_Attribute_DisplayName"))
          )
        ]),
        _vm._v(" "),
        _c(
          "v-select",
          {
            staticClass: "form-control",
            attrs: {
              options: _vm.attributes,
              disabled: _vm.attributes.length === 0,
              clearable: false
            },
            model: {
              value: _vm.newValue,
              callback: function($$v) {
                _vm.newValue = $$v
              },
              expression: "newValue"
            }
          },
          [_c("div", { attrs: { slot: "no-options" }, slot: "no-options" })]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("label", [
          _vm._v(_vm._s(_vm.resource("IOFormat_Attribute_Type_DisplayName")))
        ]),
        _vm._v(" "),
        _c(
          "v-select",
          {
            staticClass: "form-control",
            attrs: {
              options: _vm.types,
              label: "text",
              disabled: _vm.types.length === 0,
              clearable: false
            },
            model: {
              value: _vm.newType,
              callback: function($$v) {
                _vm.newType = $$v
              },
              expression: "newType"
            }
          },
          [_c("div", { attrs: { slot: "no-options" }, slot: "no-options" })]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "grid-right" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-danger",
          on: {
            click: function($event) {
              return _vm.$emit("delete", _vm.value.id)
            }
          }
        },
        [_c("i", { staticClass: "fas fa-trash-alt" })]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }